/**
 * Mobile Search Popup Component
 * Opens a search popup when clicking the magnifying glass icon on mobile/tablet
 */

class MobileSearchPopup extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.mobile-search-popup__trigger');
    this.content = this.querySelector('.mobile-search-popup__content');
    this.closeBtn = this.querySelector('.mobile-search-popup__close');
    this.overlay = this.querySelector('.mobile-search-popup__overlay');
    this.searchInput = this.querySelector('.algolia-autocomplete__input');

    this.bindEvents();
  }

  bindEvents() {
    this.trigger?.addEventListener('click', this.open.bind(this));
    this.closeBtn?.addEventListener('click', this.close.bind(this));
    this.overlay?.addEventListener('click', this.close.bind(this));

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  isOpen() {
    return !this.content?.hidden;
  }

  open() {
    if (!this.content) return;

    this.content.hidden = false;
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden-mobile-search');

    // Focus the search input after animation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.searchInput?.focus();
      });
    });
  }

  close() {
    if (!this.content) return;

    this.content.hidden = true;
    this.trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-mobile-search');

    // Clear search input
    if (this.searchInput) {
      this.searchInput.value = '';
      // Trigger input event to clear suggestions
      this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Return focus to trigger
    this.trigger?.focus();
  }
}

customElements.define('mobile-search-popup', MobileSearchPopup);
